import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer role="contentinfo">
      <div className="wrapper">
        <div className="region region-footer">
          <div id="block-hkustfooterblockaffiliate" className="block block-hkust-signature-affiliate block-footer-block">
            <div className="wrapper">
              <div className="block-body">
                <div className="footer">
                  <div className="content-locator">
                    {/* Left Section - HKUST Logo and Links */}
                    <div className="site-col">
                      <div className="hkust-logo desktop">
                        <a href="https://www.ust.hk" target="_blank" rel="noreferrer">
                          <img src="/images/hkust/hkust_logo_small.svg" alt="HKUST Logo" />
                        </a>
                      </div>
                      <div className="site-pages">
                        <a className="page" href="https://dataprivacy.ust.hk/university-data-privacy-policy-statement/" target="_blank" rel="noreferrer">Privacy</a>
                        <a className="page" href="/sitemap">Sitemap</a>
                        <div className="copyright desktop">Copyright © The Hong Kong University of Science and Technology. All rights reserved.</div>
                      </div>
                    </div>

                    {/* Social Media Section */}
                    <div className="social-share-col">
                      <div className="text">Follow HKUST on</div>
                      <div className="icon-wrapper">
                        <a className="page" href="https://www.facebook.com/hkust" target="_blank" rel="noopener noreferrer">
                          <img src='/images/hkust/menu_icons/s-icon-fb.svg' alt='FaceBook' />
                          <div className='visually-hidden'>FaceBook</div>
                        </a>
                        <a className="page" href="https://www.instagram.com/hkust" target="_blank" rel="noopener noreferrer">
                          <img src='/images/hkust/menu_icons/s-icon-ig.svg' alt='ig' />
                          <div className='visually-hidden'>ig</div>
                        </a>
                        <a className="page" href="https://www.linkedin.com/school/hkust" target="_blank" rel="noopener noreferrer">
                          <img src='/images/hkust/menu_icons/s-icon-in.svg' alt='LinkedIn' />
                          <div className='visually-hidden'>LinkedIn</div>
                        </a>
                        <a className="page" href="https://www.youtube.com/hkust" target="_blank" rel="noopener noreferrer">
                          <img src='/images/hkust/menu_icons/s-icon-youtube.svg' alt='youtube' />
                          <div className='visually-hidden'>youtube</div>
                        </a>
                        <a className="page" href="https://weixin.qq.com" target="_blank" rel="noopener noreferrer">
                          <img src='/images/hkust/menu_icons/WeChat.svg' alt='Wechat' />
                          <div className='visually-hidden'>Wechat</div>
                        </a>
                      </div>
                    </div>

                    {/* Mobile HKUST Logo */}
                    <div className="hkust-logo mobile">
                      <a href="https://www.ust.hk" target="_blank" rel="noreferrer">
                        <img src="/images/hkust/hkust_logo_small.svg" alt="HKUST Logo" />
                      </a>
                    </div>

                    {/* Caring Organisation Logo */}
                    <div className="caring">
                      <span>
                        <img src="/images/hkust/5Year_caringLogo-01.png" alt="Caring Logo" />
                      </span>
                    </div>

                    {/* Mobile Copyright */}
                    <div className="copyright mobile">Copyright © The Hong Kong University of Science and Technology. All rights reserved.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="region-split region-footer page-container">
          <div className="col"></div>
          <div className="col"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
